import * as go from 'gojs';
import type { Size } from './types';
import { defaultImageSize } from './types';
import type { BaseNodeData, CrusherNodeData } from 'gojs/types';

export const mirroredImageBinding = () =>
  new go.Binding('flip', 'mirrored', (mirrored: BaseNodeData['mirrored']) => {
    return mirrored ? go.GraphObject.FlipHorizontal : go.GraphObject.None;
  });

export const getDefaultPictureSize = (size: Size, margin: number) => ({
  ...size,
  margin: new go.Margin(margin, margin, margin, margin),
});

export const getImageBinding =
  (key: string, getImage: (arg: any) => string) => () =>
    new go.Binding('source', key, getImage);

const isTall = (arg: BaseNodeData): boolean =>
  (arg as CrusherNodeData)?.useHighBin ?? false;

export const getImageWidth = (node: any, defaultWidth: number): number => {
  return isTall(node) ? defaultImageSize.tall.width : defaultWidth;
};

export const getImageHeight = (node: any, defaultHeight: number): number => {
  return isTall(node) ? defaultImageSize.tall.height : defaultHeight;
};

export const getImageWidthBinding = (defaultWidth: number): go.Binding => {
  return new go.Binding('width', '', (arg: any) =>
    getImageWidth(arg, defaultWidth),
  );
};

export const getImageHeightBinding = (defaultHeight: number): go.Binding => {
  return new go.Binding('height', '', (arg: any) =>
    getImageHeight(arg, defaultHeight),
  );
};
